
import * as _ref_Li9maXJlYmFzZS9hdXRoLmpz_ from './firebase/auth.js';
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import { instantiate } from './composeApp.uninstantiated.mjs';


const exports = (await instantiate({
    './firebase/auth.js': _ref_Li9maXJlYmFzZS9hdXRoLmpz_,
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_
})).exports;

export const {
    memory,
    _initialize,
    startUnitTests
} = exports;

